<app-main-layout class="landing-page">
  <app-hero></app-hero>
  <app-home-main></app-home-main>
  <app-footnote></app-footnote>
</app-main-layout>
